import React from "react";
import CustomIcon from "../../../components/general/CustomIcon";
import {Tooltip} from "@material-tailwind/react";

interface Props {
    toolTip?: string;
    value?: string | number;
    iconName?: string;
    classNameIcon?: string;
}
export default function InfoData({toolTip, value, iconName, classNameIcon}: Props) {
    return (
        <Tooltip className={"bg-header tooltip cursor-pointer"} content={toolTip}>
            <div className={'!border border-secondary rounded-[5px] flex gap-2 p-1 items-center'}>
                <CustomIcon className={classNameIcon} {...{iconName}}/>
                <span className={'text-[14px]'}>{value}</span>
            </div>
        </Tooltip>
    )
}